// JS

import './js/main.js';

// CSS

import './scss/main.scss';

// Images

import './img/quote.png';
import './img/alarm-icon.svg';
import './img/alarm-icon-white.svg';
import './img/trustpilot-stars-5.svg';

import './img/favicon.ico';
import './img/favicon-192.png';
import './img/favicon-160.png';
import './img/favicon-96.png';
import './img/favicon-64.png';
import './img/favicon-32.png';
import './img/favicon-16.png';
import './img/favicon-57.png';
import './img/favicon-114.png';
import './img/favicon-72.png';
import './img/favicon-144.png';
import './img/favicon-144.png';
import './img/favicon-60.png';
import './img/favicon-120.png';
import './img/favicon-76.png';
import './img/favicon-152.png';
import './img/favicon-180.png';

// In-page menu icons

import './img/inpagemenu/aeroplane.svg';
import './img/inpagemenu/aeroplane-white.svg';
import './img/inpagemenu/alert.svg';
import './img/inpagemenu/alert-white.svg';
import './img/inpagemenu/arrow-right.svg';
import './img/inpagemenu/arrow-right-white.svg';
import './img/inpagemenu/bar.svg';
import './img/inpagemenu/bar-white.svg';
import './img/inpagemenu/bell.svg';
import './img/inpagemenu/bell-white.svg';
import './img/inpagemenu/bell-alert.svg';
import './img/inpagemenu/bell-alert-white.svg';
import './img/inpagemenu/bin.svg';
import './img/inpagemenu/bin-white.svg';
import './img/inpagemenu/board.svg';
import './img/inpagemenu/board-white.svg';
import './img/inpagemenu/box.svg';
import './img/inpagemenu/box-white.svg';
import './img/inpagemenu/bulb.svg';
import './img/inpagemenu/bulb-white.svg';
import './img/inpagemenu/bullet.svg';
import './img/inpagemenu/bullet-white.svg';
import './img/inpagemenu/calculator.svg';
import './img/inpagemenu/calculator-white.svg';
import './img/inpagemenu/calendar.svg';
import './img/inpagemenu/calendar-white.svg';
import './img/inpagemenu/car.svg';
import './img/inpagemenu/car-white.svg';
import './img/inpagemenu/card.svg';
import './img/inpagemenu/card-white.svg';
import './img/inpagemenu/chat.svg';
import './img/inpagemenu/chat-white.svg';
import './img/inpagemenu/chevron-down.svg';
import './img/inpagemenu/chevron-down-white.svg';
import './img/inpagemenu/chevron-left.svg';
import './img/inpagemenu/chevron-left-white.svg';
import './img/inpagemenu/chevron-right.svg';
import './img/inpagemenu/chevron-right-white.svg';
import './img/inpagemenu/chevron-up.svg';
import './img/inpagemenu/chevron-up-white.svg';
import './img/inpagemenu/clock.svg';
import './img/inpagemenu/clock-white.svg';
import './img/inpagemenu/close.svg';
import './img/inpagemenu/close-white.svg';
import './img/inpagemenu/coins.svg';
import './img/inpagemenu/coins-white.svg';
import './img/inpagemenu/cross.svg';
import './img/inpagemenu/cross-white.svg';
import './img/inpagemenu/document.svg';
import './img/inpagemenu/document-white.svg';
import './img/inpagemenu/eye.svg';
import './img/inpagemenu/eye-white.svg';
import './img/inpagemenu/eye-closed.svg';
import './img/inpagemenu/eye-closed-white.svg';
import './img/inpagemenu/filter.svg';
import './img/inpagemenu/filter-white.svg';
import './img/inpagemenu/home.svg';
import './img/inpagemenu/home-white.svg';
import './img/inpagemenu/key.svg';
import './img/inpagemenu/key-white.svg';
import './img/inpagemenu/link.svg';
import './img/inpagemenu/link-white.svg';
import './img/inpagemenu/log-out.svg';
import './img/inpagemenu/log-out-white.svg';
import './img/inpagemenu/mail.svg';
import './img/inpagemenu/mail-white.svg';
import './img/inpagemenu/mail-alert.svg';
import './img/inpagemenu/mail-alert-white.svg';
import './img/inpagemenu/menu-right.svg';
import './img/inpagemenu/menu-right-white.svg';
import './img/inpagemenu/minus.svg';
import './img/inpagemenu/minus-white.svg';
import './img/inpagemenu/pen.svg';
import './img/inpagemenu/pen-white.svg';
import './img/inpagemenu/percent.svg';
import './img/inpagemenu/percent-white.svg';
import './img/inpagemenu/performance.svg';
import './img/inpagemenu/performance-white.svg';
import './img/inpagemenu/phone.svg';
import './img/inpagemenu/phone-white.svg';
import './img/inpagemenu/pie.svg';
import './img/inpagemenu/pie-white.svg';
import './img/inpagemenu/plus.svg';
import './img/inpagemenu/plus-white.svg';
import './img/inpagemenu/pound.svg';
import './img/inpagemenu/pound-white.svg';
import './img/inpagemenu/question-mark.svg';
import './img/inpagemenu/question-mark-white.svg';
import './img/inpagemenu/search.svg';
import './img/inpagemenu/search-white.svg';
import './img/inpagemenu/shield.svg';
import './img/inpagemenu/shield-white.svg';
import './img/inpagemenu/speech.svg';
import './img/inpagemenu/speech-white.svg';
import './img/inpagemenu/star.svg';
import './img/inpagemenu/star-white.svg';
import './img/inpagemenu/tick.svg';
import './img/inpagemenu/tick-white.svg';
import './img/inpagemenu/unit.svg';
import './img/inpagemenu/unit-white.svg';
import './img/inpagemenu/user.svg';
import './img/inpagemenu/user-white.svg';
import './img/inpagemenu/wallet.svg';
import './img/inpagemenu/wallet-white.svg';
// Images spotlight widget
import './img/spotlight/spotlight-5-stars.svg';
import './img/spotlight/spotlight-5-stars-white.svg';
import './img/spotlight/spotlight-advice.svg';
import './img/spotlight/spotlight-advice-white.svg';
import './img/spotlight/spotlight-aeroplane.svg';
import './img/spotlight/spotlight-aeroplane-white.svg';
import './img/spotlight/spotlight-apple.svg';
import './img/spotlight/spotlight-apple-white.svg';
import './img/spotlight/spotlight-award.svg';
import './img/spotlight/spotlight-award-white.svg';
import './img/spotlight/spotlight-bar-chart.svg';
import './img/spotlight/spotlight-bar-chart-white.svg';
import './img/spotlight/spotlight-bell.svg';
import './img/spotlight/spotlight-bell-white.svg';
import './img/spotlight/spotlight-bell-alert.svg';
import './img/spotlight/spotlight-bell-alert-white.svg';
import './img/spotlight/spotlight-board.svg';
import './img/spotlight/spotlight-board-white.svg';
import './img/spotlight/spotlight-building.svg';
import './img/spotlight/spotlight-building-white.svg';
import './img/spotlight/spotlight-bulb.svg';
import './img/spotlight/spotlight-bulb-white.svg';
import './img/spotlight/spotlight-calc.svg';
import './img/spotlight/spotlight-calc-white.svg';
import './img/spotlight/spotlight-calendar.svg';
import './img/spotlight/spotlight-calendar-white.svg';
import './img/spotlight/spotlight-calendar-confirm.svg';
import './img/spotlight/spotlight-calendar-confirm-white.svg';
import './img/spotlight/spotlight-car.svg';
import './img/spotlight/spotlight-car-white.svg';
import './img/spotlight/spotlight-chat.svg';
import './img/spotlight/spotlight-chat-white.svg';
import './img/spotlight/spotlight-clock.svg';
import './img/spotlight/spotlight-clock-white.svg';
import './img/spotlight/spotlight-cog.svg';
import './img/spotlight/spotlight-cog-white.svg';
import './img/spotlight/spotlight-coin-growth.svg';
import './img/spotlight/spotlight-coin-growth-white.svg';
import './img/spotlight/spotlight-coin-stack.svg';
import './img/spotlight/spotlight-coin-stack-white.svg';
import './img/spotlight/spotlight-conversation.svg';
import './img/spotlight/spotlight-conversation-white.svg';
import './img/spotlight/spotlight-credit-card.svg';
import './img/spotlight/spotlight-credit-card-white.svg';
import './img/spotlight/spotlight-dental.svg';
import './img/spotlight/spotlight-dental-white.svg';
import './img/spotlight/spotlight-dental-building.svg';
import './img/spotlight/spotlight-dental-building-white.svg';
import './img/spotlight/spotlight-document.svg';
import './img/spotlight/spotlight-document-white.svg';
import './img/spotlight/spotlight-document-with-speech.svg';
import './img/spotlight/spotlight-document-with-speech-white.svg';
import './img/spotlight/spotlight-education.svg';
import './img/spotlight/spotlight-education-white.svg';
import './img/spotlight/spotlight-fact-find.svg';
import './img/spotlight/spotlight-fact-find-white.svg';
import './img/spotlight/spotlight-finance-conversation.svg';
import './img/spotlight/spotlight-finance-conversation-white.svg';
import './img/spotlight/spotlight-financial-plan.svg';
import './img/spotlight/spotlight-financial-plan-white.svg';
import './img/spotlight/spotlight-globe.svg';
import './img/spotlight/spotlight-globe-white.svg';
import './img/spotlight/spotlight-gp.svg';
import './img/spotlight/spotlight-gp-white.svg';
import './img/spotlight/spotlight-graph.svg';
import './img/spotlight/spotlight-graph-white.svg';
import './img/spotlight/spotlight-handshake.svg';
import './img/spotlight/spotlight-handshake-white.svg';
import './img/spotlight/spotlight-hand-with-coins.svg';
import './img/spotlight/spotlight-hand-with-coins-white.svg';
import './img/spotlight/spotlight-hospital.svg';
import './img/spotlight/spotlight-hospital-white.svg';
import './img/spotlight/spotlight-house.svg';
import './img/spotlight/spotlight-house-white.svg';
import './img/spotlight/spotlight-key.svg';
import './img/spotlight/spotlight-key-white.svg';
import './img/spotlight/spotlight-location-pin.svg';
import './img/spotlight/spotlight-location-pin-white.svg';
import './img/spotlight/spotlight-log-out.svg';
import './img/spotlight/spotlight-log-out-white.svg';
import './img/spotlight/spotlight-mail.svg';
import './img/spotlight/spotlight-mail-white.svg';
import './img/spotlight/spotlight-mail-alert.svg';
import './img/spotlight/spotlight-mail-alert-white.svg';
import './img/spotlight/spotlight-medic.svg';
import './img/spotlight/spotlight-medic-white.svg';
import './img/spotlight/spotlight-medical-building.svg';
import './img/spotlight/spotlight-medical-building-white.svg';
import './img/spotlight/spotlight-pen.svg';
import './img/spotlight/spotlight-pen-white.svg';
import './img/spotlight/spotlight-people.svg';
import './img/spotlight/spotlight-people-white.svg';
import './img/spotlight/spotlight-person.svg';
import './img/spotlight/spotlight-person-white.svg';
import './img/spotlight/spotlight-person-1.svg';
import './img/spotlight/spotlight-person-1-white.svg';
import './img/spotlight/spotlight-personal-file.svg';
import './img/spotlight/spotlight-personal-file-white.svg';
import './img/spotlight/spotlight-phone.svg';
import './img/spotlight/spotlight-phone-white.svg';
import './img/spotlight/spotlight-pie-chart.svg';
import './img/spotlight/spotlight-pie-chart-white.svg';
import './img/spotlight/spotlight-piggy-bank.svg';
import './img/spotlight/spotlight-piggy-bank-white.svg';
import './img/spotlight/spotlight-pram.svg';
import './img/spotlight/spotlight-pram-white.svg';
import './img/spotlight/spotlight-question-mark.svg';
import './img/spotlight/spotlight-question-mark-white.svg';
import './img/spotlight/spotlight-rocking-chair.svg';
import './img/spotlight/spotlight-rocking-chair-white.svg';
import './img/spotlight/spotlight-shield.svg';
import './img/spotlight/spotlight-shield-white.svg';
import './img/spotlight/spotlight-shield-with-tick.svg';
import './img/spotlight/spotlight-shield-with-tick-white.svg';
import './img/spotlight/spotlight-speech.svg';
import './img/spotlight/spotlight-speech-white.svg';
import './img/spotlight/spotlight-toggle.svg';
import './img/spotlight/spotlight-toggle-white.svg';
import './img/spotlight/spotlight-tree.svg';
import './img/spotlight/spotlight-tree-white.svg';
import './img/spotlight/spotlight-wind-turbine.svg';
import './img/spotlight/spotlight-wind-turbine-white.svg';



// Fonts

import './fonts/open-sans-v40-latin-regular.woff2';
import './fonts/open-sans-v40-latin-italic.woff2';
import './fonts/open-sans-v40-latin-500.woff2';
import './fonts/open-sans-v40-latin-500italic.woff2';
import './fonts/open-sans-v40-latin-600.woff2';
import './fonts/open-sans-v40-latin-600italic.woff2';
import './fonts/open-sans-v40-latin-700.woff2';
import './fonts/open-sans-v40-latin-700italic.woff2';
import './fonts/open-sans-v40-latin-800.woff2';
import './fonts/open-sans-v40-latin-800italic.woff2';
import './fonts/cabin-v27-latin-regular.woff2';
import './fonts/cabin-v27-latin-italic.woff2';
import './fonts/cabin-v27-latin-500.woff2';
import './fonts/cabin-v27-latin-500italic.woff2';
import './fonts/cabin-v27-latin-600.woff2';
import './fonts/cabin-v27-latin-600italic.woff2';
import './fonts/cabin-v27-latin-700.woff2';
import './fonts/cabin-v27-latin-700italic.woff2';
